import { render, staticRenderFns } from "./FabricSelector.vue?vue&type=template&id=7eccf42f&"
import script from "./FabricSelector.vue?vue&type=script&lang=ts&"
export * from "./FabricSelector.vue?vue&type=script&lang=ts&"
import style0 from "./FabricSelector.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports